import classNames from 'classnames';
import { FC, ReactNode } from 'react';

interface ListGroupProps {
  children: ReactNode;
  className?: string;
  e2e?: string;
}

export const ListGroup: FC<ListGroupProps> = ({ children, className, e2e }) => (
  <ul className={classNames('list-group list-group-flush', className)} data-e2e={e2e}>
    {children}
  </ul>
);
